<template>
  <div v-if="$route.path !== '/login'" ref="wg-world-menu">
    <!-- Menu collassato -->
    <div id="anm22_world_menu_small">
      <template v-if="userLogged">
        <!-- Work Logo -->
        <div v-if="!customMode" class="anm22_world_menu_small_box license selected">
          <div class="anm22_world_menu_small_box_container">
            <a :href="enviromentMode === 'production' ? 'https://www.anm22.it/app/work/' : frontDomain + '/app/work/'">
              <div class="anm22_world_menu_small_box_image">
                <world-object-icon
                    :type="'work'" 
                    :obj="work"
                    :isImg="true"
                    :defaultImg="'workDefault'"
                    :square="true">
                </world-object-icon>
              </div>
              <!-- <img
              
                class="anm22_world_menu_small_box_image"
                :src="$anm22.getObjIcon(work, 'workDefault')"
              > -->
            </a>
          </div>
        </div>
        <div v-else class="anm22_world_menu_small_box license selected">
          <div class="anm22_world_menu_small_box_container">
            <a 
                href="javascript:;"
                @mouseup="itemClick($event, customWorkItem)"
                :title="customWorkItem.work ? customWorkItem.work.name : 'Work'">
              <div class="anm22_world_menu_small_box_image">
                <world-object-icon
                    :type="'work'" 
                    :obj="customWorkItem.work"
                    :isImg="true"
                    :defaultImg="'workDefault'"
                    :square="true">
                </world-object-icon>
              </div>
              <!-- <img
                class="anm22_world_menu_small_box_image"
                :src="customWorkItem.icon"
              > -->
            </a>
          </div>
        </div>
        <div
          v-for=" (category, index) in menuCategories"
          :key="'small-c-'+index"
        >
          <div v-if="category.items.length > 0" class="anm22_world_menu_line"></div>
          <div v-for=" (item, index) in getFilteredItems(category)" :key="'small-i-'+index">
            <div
              :class="['anm22_world_menu_small_box', pageSelected === item.selectId ? 'selected' : '']"
            >
              <div class="anm22_world_menu_small_box_container">
                <a href="javascript:;" @mouseup="itemClick($event, item)" :title="item.description">
                  <img 
                      :class="['anm22_world_menu_small_box_image', item.iconHover ? 'no-hover' : '']" 
                      :src="item.icon" 
                      :style="item.style">
                  <img 
                      v-if="item.iconHover" 
                      class="anm22_world_menu_small_box_image hover" 
                      :src="item.iconHover" 
                      :style="item.style">
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        v-else
        class="anm22_world_menu_small_box"
      >
        <div class="anm22_world_menu_small_box_container">
          <router-link to="/login" tag="a">
            <img 
                class="anm22_world_menu_small_box_image" 
                :src="$anm22.icons.getWorldIcon('menuLogin')">
          </router-link>
        </div>
      </div>
      <div class="anm22_world_menu_line"></div>
      <div class="anm22_world_menu_small_box selected" v-if="menuTheme == 'anm22'">
        <div class="anm22_world_menu_small_box_container">
          <a href="https://www.anm22.it" target="_blank" title="ANM22">
            <img
              class="anm22_world_menu_small_box_image"
              :src="$anm22.icons.getWorldIcon('menuBeTasker')"
            >
          </a>
        </div>
      </div>
      <div class="anm22_world_menu_small_box selected" v-if="menuTheme == 'spiagge'">
        <div class="anm22_world_menu_small_box_container">
          <a href="https://www.spiagge.it" target="_blank" title="Spiagge.it">
            <img
              class="anm22_world_menu_small_box_image"
              :src="$anm22.icons.getWorldIcon('menuSpiagge')"
            >
          </a>
        </div>
      </div>
      <!-- Icona che mostra che del contenuto sta venendo scaricato dal cloud -->
      <div v-show="isDownloading || isSaving" class="wg-row sync-icon-div">
        <div class="anm22_world_menu_small_box">
          <div class="anm22_world_menu_small_box_container">
            <img 
                class="anm22_world_menu_small_box_image"
                :src="$anm22.icons.getWorldIcon('sync')"
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Menu espanso -->
    <div id="menu" :style="[menuOpenLocal ? {left: '0px'} : {left: '-260px'}]">
      <template v-if="userLogged">
        <!-- Work Logo -->
        <div v-if="!customMode" class="anm22_world_menu_box license selected">
          <a :href="enviromentMode === 'production' ? 'https://www.anm22.it/app/work/' : frontDomain + '/app/work/'">
            <div class="image">
              <world-object-icon
                  :type="'work'" 
                  :obj="work"
                  :isImg="true"
                  :defaultImg="'workDefault'"
                  :square="true">
              </world-object-icon>
            </div>
            <!-- <img
              :src="$anm22.getObjIcon(work, 'workDefault')"
            > -->
            <div class="desc" >
              {{ work.name || 'Work' }}
            </div>
          </a>
        </div>
        <div v-else class="anm22_world_menu_box license selected">
          <a 
              href="javascript:;"
              @mouseup="itemClick($event, customWorkItem)"
              :title="customWorkItem.work ? customWorkItem.work.name : 'Work'">
            <div class="image">
              <world-object-icon
                  :type="'work'" 
                  :obj="customWorkItem.work"
                  :isImg="true"
                  :square="true">
              </world-object-icon>
            </div>
            <div class="desc" >
              {{ customWorkItem.work ? customWorkItem.work.name : 'Work' }}
            </div>
          </a>
        </div>
        <div
          v-for=" (category, index) in menuCategories"
          :key="'big-c-'+index"
        >
          <div v-if="category.items.length > 0" class="anm22_world_menu_line"></div>
          <div v-for=" (item, index) in getFilteredItems(category)" :key="'big-i-'+index">
            <div class="anm22_world_menu_box">
              <a href="javascript:;" @mouseup="itemClick($event, item)" :title="item.description" :data-cy="'barmenu-'+ item.name">
                <img :src="item.iconHover ? item.iconHover : item.icon" :style="item.style">
                <div class="desc" :style="{fontWeight: pageSelected === item.selectId ? 'bold' : ''}">{{ item.description }}</div>
              </a>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="anm22_world_menu_box">
        <router-link to="/login" tag="a">
          <img :src="$anm22.icons.getWorldIcon('menuLogin')">
          <div class="desc">{{ $anm22.strLang(lang, 'Login', 'Accedi') }}</div>
        </router-link>
      </div>
      <div class="anm22_world_menu_line"></div>
      <div v-if="menuTheme == 'anm22'">
        <a href="https://www.anm22.it" target="_blank">
          <img :src="$anm22.icons.getWorldIcon('menuBeTasker')" style="width:50px;border:0;margin:20px auto;" alt="anm22.it">
        </a>
      </div>
      <div style="margin:0 auto;width:150px;text-align:center;font-family: Arial, Helvetica, sans-serif;color:#222;font-size:9px;" v-if="menuTheme == 'anm22'">
        <div>
          ANM22 All rights Reserved
        </div>
        <a href="https://www.anm22.it/it/privacy-policy/" style="color:#222;font-size:9px;" target="_blank">
          Privacy policy
        </a>
         - 
        <a href="https://www.anm22.it/it/cookies/" style="color:#222;font-size:9px;" target="_blank">
          Cookie policy
        </a>
      </div>
      <div v-if="menuTheme == 'spiagge'">
        <a href="https://www.spiagge.it" target="_blank">
          <img :src="$anm22.icons.getWorldIcon('menuSpiagge')" style="width:50px;border:0;margin:20px auto;" alt="Spiagge.it">
        </a>
      </div>
      <div style="margin:0 auto;width:150px;text-align:center;font-family: Arial, Helvetica, sans-serif;color:#222;font-size:9px;" v-if="menuTheme == 'spiagge'">
        <div>
          Spiagge srl All rights Reserved
        </div>
        <a href="https://www.spiagge.it/privacy-policy/" style="color:#222;font-size:9px;" target="_blank">
          Privacy policy
        </a>
         - 
        <a href="https://www.spiagge.it/cookies/" style="color:#222;font-size:9px;" target="_blank">
          Cookie policy
        </a>
      </div>
      <div v-show="isDownloading || isSaving" class="wg-row sync-icon-div">
        <div class="anm22_world_menu_small_box">
          <div class="anm22_world_menu_small_box_container">
            <img 
                class="anm22_world_menu_small_box_image"
                :src="$anm22.icons.getWorldIcon('sync')"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    menuOpen: Boolean,
    menuTheme: {
      type: String,
      default: () => 'anm22'
    }
  },
  data() {
    return {
      menuOpenLocal: this.menuOpen,
      frontDomain: process.env.VUE_APP_FRONT_DOMAIN,
      enviromentMode: process.env.NODE_ENV,  
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      workSelected: state => state.workSelected,
      user: state => state.auth.user,
      userLogged: state => state.auth.userLogged,
      menuCategories: state => state.menu.menuCategories,
      pageSelected: state => state.menu.selected,
      /* YB o FD menu */
      customMode: state => state.menu.customMode,
      customWorkItem: state => state.menu.customWork,
      // Icona downloading
      isDownloading: state => state.isDownloading,
      isSaving: state => state.isSaving
    }),
    licenses() {
      return this.$store.getters['employments/getByUser'](this.user.idWorldUser)
        .map(e => this.$store.getters['licenses/getByWork'](e.work));
    },
    work() {
      return this.workSelected !== 'my' && this.$store.getters['works/get'](this.workSelected) 
          ? this.$store.getters['works/get'](this.workSelected) : {};
    }
  },
  methods: {
    checkOutsideClick(event) {
      const me = this.$refs['wg-world-menu'];
      const headbarBtn = document.querySelector('[wg-id="wg-world-headbar-menu-btn"]');
      let target = event.target;
      if((!me || !me.contains(target)) && (!headbarBtn || !headbarBtn.contains(target))) {
        this.$emit('closeWorldMenu');
      }
    },
    getFilteredItems(category) {
      if(!this.customMode) {
        //Filtraggio in base alle impostazioni di licenza
        return category.items.filter(item => {
          if(this.licenses.length === 0) {
            return true;
          } else {
            return this.licenses.reduce((inc,l) => {
              if(l
                  && l.config.apps
                  && l.config.apps[item.name] 
                  && l.config.apps[item.name].hasOwnProperty('enabled')) {
                return inc || l.config.apps[item.name].enabled;
              } else {
                return inc;
              }
            }, true);
          }
        });
      } else {
        return category.items;
      }
    },
    itemClick(event, item) {
      this.menuOpenLocal = false;
      if(item.custom) {
        item.customAction();
      } else if(!item.external) {
        this.$router.push(item.href);
      } else {
        if(event && (event.which == 2 || event.button == 4)) {
          window.open(item.href, '_blank');
        } else {
          window.location = item.href;
        }
      }
    }
  },
  watch: {
    menuOpen(newVal) {
      this.menuOpenLocal = newVal;
    }
  },
  mounted() {
    document.addEventListener('click', this.checkOutsideClick);
  },
};
</script>

<style lang="scss" scoped>
.anm22_world_menu_box {
  .image {
    display:inline-block;
    vertical-align:middle;
    width:35px;
    height:35px;
    padding:5px;
    border:0;
    box-sizing:border-box;
    margin-right: 10px;
  }

  &.license {
    .image img {
      width: 25px;
      height: 25px;
    }
  }
}
@media only screen and (max-width: 767px) {
  #anm22_world_menu_small{
      left: -60px;
  }
}
@media only screen and (min-width: 768px) {
  #anm22_world_menu_small{
      left: 0;
  }
}
.sync-icon-div {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  left: 0;
}
</style>